module.exports = __webpack_public_path__ + "banquet/components/Navbar/images/nav_heart.a764bb5ab87e39bd3fcd3fa58b66f531.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Navbar/images/nav_heart.png
// module id = 1680
// module chunks = 1